import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';
import { message, Upload } from 'antd';

const { Dragger } = Upload;

interface UploadXlsxDraggerProps {
  fileList: UploadFile[];
  setFileList: (fileList: UploadFile[]) => void;
}

export default function UploadXlsxDragger(props: UploadXlsxDraggerProps) {
  const internalProps: UploadProps = {
    name: 'file',
    multiple: false,
    onRemove: (file) => {
      props.setFileList([]);
    },
    beforeUpload: (file) => {
      const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (isXlsx) {
        props.setFileList([file]);
      } else {
        message.error(`${file.name} is not a valid Excel file`);
      }
      return false;
    },
    fileList: props.fileList,
  };

  return (
    <Dragger {...internalProps}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click or drag mapping file here</p>
      <p className="ant-upload-hint">
        Make sure you directly upload the file from the Lark document.
        <br/>Accepts only xlsx files.
      </p>
    </Dragger>
  );
}